module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Suits_.c44473c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Suits_.jpg
// module id = X6St
// module chunks = 0